/**
 * Internal dependencies
 */
import BlockSlider from "./block-slider";

/**
 * 
 */
class BlockSliderManager {

	/**
	 * Public vars
	 */
	contextDocument = document;
	sliderList = [];
	sliderSelector = '.block-slider';

	/**
	 * 
	 */
	constructor()
	{
		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onViewportChange = this.onViewportChange.bind( this );
		this.contextDocument.addEventListener( 'WMUViewportChange', this.onViewportChange );
	}

	/**
	 * 
	 */
	clear()
	{
		this.sliderList.forEach( ( slider ) =>
		{
			slider.clear();
		} );

		this.sliderList = [];
	}

	/**
	 * 
	 */
	setup()
	{
		this.contextDocument.querySelectorAll( this.sliderSelector ).forEach( ( sliderElement ) =>
		{
			const slider = new BlockSlider( sliderElement );
			slider.setup();
			this.sliderList.push( slider );
		} );
	}

	/**
	 * Event handlers
	 */

	/**
	 * 
	 * @param {Event} event 
	 */
	onViewportChange( event )
	{
		this.clear();
		this.setup();
	}

}

export default BlockSliderManager;